import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LabelComponent } from '../../../../../../../common/label/label.component';
import {
  ApplicantAppEntityApplicantWrite,
  ApplicantAppEntityApplicationRead
} from '../../../../../../../openapi';

@Component({
  selector: 'app-applicant-item-preview',
  standalone: true,
  imports: [
    CommonModule,
    LabelComponent
  ],
  templateUrl: './applicant-item-preview.component.html'
})
export class ApplicantItemPreviewComponent {

  @Input()
  public applicant: ApplicantAppEntityApplicantWrite | ApplicantAppEntityApplicationRead | undefined;

  constructor() {
  }
}
